import Vue from 'vue'
import { map } from 'lodash'

export default {
  setDebugMsg (state, msg) {
    state.debugMsg = msg
  },
  setLiveProduct (state, productData) {
    let productIndex = state.products.findIndex(item => item.productId === productData.productId)
    if (productIndex === -1) {
      state.products.push(productData)
    } else {
      state.products.splice(productIndex, 1, productData)
    }
  },
  setLiveProducts (state, products) {
    for (let product of products) {
      let productIndex = state.products.findIndex(item => item.productId === product.productId)
      if (productIndex === -1) {
        state.products.push(product)
      } else {
        state.products.splice(productIndex, 1, product)
      }
    }
  },
  setCartProducts (state, cartProducts) {
    state.cart.cartContents = cartProducts
  },
  setCartGifts (state, cartGifts) {
    state.cart.giftContents = cartGifts
  },
  setCartGiftRules (state, cartGiftRules) {
    state.cart.giftRules = cartGiftRules
  },
  setCartErrors (state, cartErrors) {
    state.cart.cartErrors = cartErrors
  },
  setSelectedProductCodeId (state, productCodeId) {
    state.selectedProductCodeId = productCodeId
  },
  setSelectedAttributeId (state, attributeId) {
    state.selectedAttributeId = attributeId
  },
  setAllAttributes (state, data) {
    state.allAttributes = data
  },
  setProductBadges (state, data) {
    state.productBadges = data
  },
  setConfig (state, data) {
    state.config = data
  },
  setOnlineStatus (state, data) {
    state.onlineStatus = data
  },
  openProductCardModal (state, productId) {
    state.productCardModal.productId = productId
    state.productCardModal.open = true
  },
  closeProductCardModal (state) {
    state.productCardModal.open = false
    state.productCardModal.productId = null
  },
  setGiftToSelectedGifts (state, { giftId, productId, quantity }) {
    if (!state.selectedGifts.hasOwnProperty(giftId)) {
      Vue.set(state.selectedGifts, giftId, {})
    }
    const newSelectedProductGiftEntry = {
      productId: productId,
      quantity: quantity
    }
    Vue.set(state.selectedGifts[giftId], productId, newSelectedProductGiftEntry)
  },
  removeGiftFromSelectedGifts (state, { giftId, productId }) {
    if (!state.selectedGifts[giftId]) { return }
    if (!state.selectedGifts[giftId][productId]) { return }
    Vue.delete(state.selectedGifts[giftId], productId)
    if (Object.keys(state.selectedGifts[giftId]).length < 1) {
      Vue.delete(state.selectedGifts, giftId)
    }
  },
  unselectGifts (state) {
    state.selectedGifts = {}
  },
  setTransporters (state, transporters) {
    state.transporters = transporters
  },
  setPreviewOrderData (state, data) {
    state.previewOrderData = data
  },
  setCouponCode (state, data) {
    state.previewOrderData.couponCode = data
  },
  setCouponDiscount (state, data) {
    state.previewOrderData.couponDiscount = data
  },
  setTransporterId (state, transporterId) {
    state.previewOrderData.transporterId = transporterId
  },
  setMinicartGiftChoiceModal (state, payload) {
    state.minicartGiftChoiceModal = payload
  },

  setSelectedTransporterId (state, payload) {
    state.selectedTransporterId = payload
  },
  setAllTransporterSmartPoints (state, availableSmartPoints) {
    state.allTransporterSmartPoints = availableSmartPoints
  },
  setSmartPointLoading (state, loading) {
    state.smartPointLoading = loading
  },
  setSmartPointIsSelected (state, payload) {
    state.smartPointIsSelected = payload
  },
  setDefaultCoupon (state, defaultCoupon) {
    state.cart.defaultCoupon = defaultCoupon
  },
  setUriWithoutOffset (state, data) {
    state.uriWithoutOffset = data
  },
  setIsTopLevelCategory (state, data) {
    state.isTopLevelCategory = data
  },
  setCurrentPageNumber (state, data) {
    state.currentPageNumber = data
  },
  setProductCategoryData (state, data) {
    state.productCategoryData = data
  },
  setSearchInputSmartPoints (state, data) {
    state.searchInputSmartPoints = data
  },
  setMaxResultsSmartPoints (state, data) {
    state.maxResultsSmartPoints = data
  },
  setClosestSmartPoints (state, data) {
    state.closestSmartPoints = data
  },
  setCachedFilteredSearchedClosestSmartPoints (state, data) {
    state.cachedFilteredSearchedClosestSmartPoints = data
  },
  setSelectedSmartPoint (state, data) {
    state.selectedSmartPoint = data
  },
  smartPointMapCloseEvent (state) {
    state.previousPostalCodeInput = state.previewOrderData.customerData.postal
    state.searchInputSmartPoints = ''
  },
  smartPointMapOpenEvent (state) {
    if (state.selectedSmartPoint.id === 0) {
      state.cachedFilteredSearchedClosestSmartPoints = map(state.cachedFilteredSearchedClosestSmartPoints, (point) => {
        point.checked = false
        return point
      })
    }
  },
  setAddToCartComboClicked (state, payload) {
    state.addToCartComboClicked = payload
  },
  setGoogleMapLoading (state, data) {
    state.googleMapLoading = data
  },
  setMapPoints (state, data) {
    state.mapPoints = data
  },
  setGoogleService (state, data) {
    state.googleService = data
  },
  setCurrentUserGeolocation (state, data) {
    state.currentUserGeolocation = data
  },
  setCurrentUserGeolocationError (state, data) {
    state.currentUserGeolocationError = data
  },
  setCheckoutLocalErrors (state, data) {
    state.checkoutLocalErrors = data
  },
  setVatData (state, data) {
    state.previewOrderData.customerData.company_name = data.name
    state.previewOrderData.customerData.company_address = data.address
  },
  setEmptyVatData (state) {
    state.previewOrderData.customerData.company_name = ''
    state.previewOrderData.customerData.company_address = ''
  },
  setVatError (state, data) {
    state.vatError = false
    if (state.previewOrderData.customerData.country) {
      state.vatError = data
    }
  },
  setCheckoutVatApiDebounceTimeout (state, timeout) {
    state.checkoutVatApiDebounceTimeout = timeout
  },
  setSelectedCurrency (state, selectedCurrency) {
    state.selectedCurrency = selectedCurrency
  },
  setInitializedWidgetsForSmartPoints (state, data) {
    state.initializedWidgetsForSmartPoints = data
  }
}
